// Size presets (Bootstrap-like). Unlisted size → standard defaults. `indicatorPadding`
// trims the dropdown arrow's vertical padding so the control matches the button height
// (otherwise the indicator inflates the control above min-height).
const SIZES = {
  sm: {
    minHeight: 'calc(1.3125rem + 0.5rem + 2px)', // rem-based so it matches btn-sm regardless of font
    paddingY: '0.25rem',
    paddingX: '0.5rem',
    fontSize: '0.8125rem',
    indicatorPadding: '0 0.375rem',
  },
  lg: {
    minHeight: 'calc(1.5em + 1rem + 2px)',
    paddingY: '0.5rem',
    paddingX: '1rem',
    fontSize: '1.125rem',
    indicatorPadding: '0.5rem',
  },
}

const DEFAULTS = {
  minHeight: null,
  paddingY: 'var(--tblr-form-select-padding-y)',
  paddingX: 'var(--tblr-form-select-padding-x)',
  fontSize: '0.875rem',
  indicatorPadding: null,
}

export default function buildStyles(size) {
  const s = { ...DEFAULTS, ...(SIZES[size] || {}) }

  return {
    control: (base, { isFocused }) => ({
      ...base,
      ...(s.minHeight ? { minHeight: s.minHeight } : {}),
      fontSize: s.fontSize,
      borderColor: isFocused ? 'var(--tblr-form-select-focus-border-color)' : 'var(--tblr-form-select-border-color)',
      borderRadius: 'var(--tblr-form-select-border-radius)',
      borderWidth: 'var(--tblr-form-select-border-width)',
      boxShadow: isFocused ? 'var(--tblr-form-select-focus-box-shadow)' : 'var(--tblr-form-select-box-shadow)',
      color: 'var(--tblr-form-select-color)',
      transition: 'var(--tblr-form-select-transition)',
      '&:hover': {
        borderColor: isFocused ? 'var(--tblr-form-select-focus-border-color)' : 'var(--tblr-form-select-border-color)',
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: `${s.paddingY} 0 ${s.paddingY} ${s.paddingX}`,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      ...(s.indicatorPadding ? { padding: s.indicatorPadding } : {}),
    }),
    clearIndicator: (base) => ({
      ...base,
      ...(s.indicatorPadding ? { padding: s.indicatorPadding } : {}),
    }),
    singleValue: (base) => ({
      ...base,
      color: 'var(--tblr-form-select-color)',
      marginLeft: 0,
      marginRight: 0,
    }),
    input: (base) => ({
      ...base,
      color: 'var(--tblr-form-select-color)',
      paddingBottom: 0,
      paddingTop: 0,
      margin: 0,
    }),
    menu: (base) => ({
      ...base,
      fontSize: s.fontSize,
      border: 'var(--tblr-dropdown-border-width) solid var(--tblr-dropdown-border-color)',
      borderRadius: 'var(--tblr-dropdown-border-radius)',
      boxShadow: 'var(--tblr-dropdown-box-shadow)',
    }),
    menuList: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      color: isFocused ? 'var(--tblr-dropdown-link-active-color)' : 'var(--tblr-dropdown-link-color)',
      backgroundColor: isFocused || isSelected ? 'var(--tblr-dropdown-link-active-bg)' : 'transparent',
      padding: 'var(--tblr-dropdown-item-padding-y) var(--tblr-dropdown-item-padding-x)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      ':active': {
        backgroundColor: undefined,
      },
    }),
  }
}
